{
	"v": "4.8.0",
	"meta": { "g": "LottieFiles AE 1.0.0", "a": "", "k": "", "d": "", "tc": "" },
	"fr": 60,
	"ip": 0,
	"op": 130,
	"w": 512,
	"h": 512,
	"nm": "HDFC Success",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "check",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [256, 256, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[-82.5, 4.5],
										[-31, 55],
										[73, -52.5]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": { "a": 0, "k": 0, "ix": 1 },
							"e": {
								"a": 1,
								"k": [
									{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [1], "y": [0.076] }, "t": 60, "s": [0] },
									{ "t": 85, "s": [100] }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 0, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 30, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 240,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Shape Layer 2",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [256, 257.86, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": {
					"a": 1,
					"k": [
						{
							"i": { "x": [0, 0, 0.833], "y": [0.98, 0.98, -66.114] },
							"o": { "x": [0.656, 0.656, 0.167], "y": [0.872, 0.872, 67.114] },
							"t": 20,
							"s": [0, 0, 100]
						},
						{ "t": 60, "s": [150, 150, 100] }
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [236, 236], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.36470588235294116, 0.6, 0.3843137254901961, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, -3], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 240,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.626], "y": [0.729] }, "o": { "x": [0.912], "y": [0.073] }, "t": 76, "s": [100] },
						{ "t": 119, "s": [0] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [256, 257.86, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": {
					"a": 1,
					"k": [
						{
							"i": { "x": [0, 0, 0.667], "y": [0.999, 0.999, 1] },
							"o": { "x": [0.477, 0.477, 0.333], "y": [0.587, 0.587, 0] },
							"t": 10,
							"s": [0, 0, 100]
						},
						{
							"i": { "x": [0.833, 0.833, 0.833], "y": [1, 1, 1] },
							"o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
							"t": 50,
							"s": [150, 150, 100]
						},
						{
							"i": { "x": [0.833, 0.833, 0.833], "y": [1, 1, 1] },
							"o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
							"t": 76,
							"s": [150, 150, 100]
						},
						{ "t": 123, "s": [210, 210, 100] }
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [236, 236], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.7843137254901961, 0.8666666666666667, 0.7843137254901961, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, -3], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 240,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "BG",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [256, 256, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [554, 556], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-1, 6], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 240,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
}
